<template>
  <div :class="classes.root" :style="styles.root">
    <svg class="circular-progress__spinner" :viewBox="`0 0 ${width + 1} ${width + 1}`" xmlns="http://www.w3.org/2000/svg">
      <circle class="path"
              fill="none"
              :stroke-width="stroke"
              stroke-linecap="round"
              :cx="xy"
              :cy="xy"
              :r="radius"></circle>
    </svg>
    <div class="circular_progress__label">
      <slot>{{ label }}</slot>
    </div>
  </div>
</template>

<style lang="scss">
  $offset: 187;
  $duration: 1.4s;

  .circular-progress{
    margin: 30px auto;

    &__spinner {
      width: 100%;
      height: 100%;
      animation: rotator $duration linear infinite;

      .path {
        stroke-dasharray: $offset;
        stroke-dashoffset: 0;
        transform-origin: center;
        animation:
          dash $duration ease-in-out infinite,
          colors ($duration*4) ease-in-out infinite;
      }
    }
    &__label {
      text-align: center;
      font-size: 0.7rem;
      font-style: italic;
    }
  }

  @keyframes rotator {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(270deg); }
  }

  @keyframes colors {
    0% { stroke: #4285F4; }
    25% { stroke: #DE3E35; }
    50% { stroke: #F7C223; }
    75% { stroke: #1B9A59; }
    100% { stroke: #4285F4; }
  }

  @keyframes dash {
    0% { stroke-dashoffset: $offset; }
    50% {
      stroke-dashoffset: $offset/4;
      transform:rotate(135deg);
    }
    100% {
      stroke-dashoffset: $offset;
      transform:rotate(450deg);
    }
  }
</style>

<script>
/**
 * This component has no functional purpose other than to look pretty
 */
export default {
  name: 'CircularProgress',
  props: {
    width: {
      type: Number,
      default: 65,
    },
    stroke: {
      type: Number,
      default: 6,
    },
    label: {
      type: String,
      default: 'Loading...',
    },
  },
  computed: {
    xy() {
      return Math.ceil(this.width / 2);
    },
    radius() {
      return Math.ceil(this.width / 2) - (this.stroke / 2);
    },
  },
  data() {
    return {
      classes: {
        root: {
          'circular-progress': true,
        },
      },
      styles: {
        root: {
          width: `${this.width}px`,
          height: `${this.width}px`,
        },
      },
    };
  },
};
</script>
